import React, { Component } from "react";
import {
  Card,
  Grid,
} from "@material-ui/core";

class ComingSoon extends Component {
  state = {};
  render() {
    return (

      <div className="signup flex flex-center w-100 h-100vh">
        <div className="p-8">
          <Card className="signup-card position-relative y-center">
            <Grid container>
              <Grid item lg={5} md={5} sm={5} xs={12}>
                <div className="p-32 flex flex-center flex-middle h-100">
                  <img src="/assets/images/Tunl-Logo.png" alt="" />
                </div>
              </Grid>
              <Grid item lg={7} md={7} sm={7} xs={12}>
                <div className="p-36 h-100 bg-light-gray">
                  <br/>
                  <h2>We're Coming Soon</h2>
                </div>
              </Grid>
            </Grid>
          </Card>
        </div>
      </div>
    );
  }
}

export default ComingSoon;
